module.exports = __webpack_public_path__ + "img/AliffLogo.5984eb5d.png";